/* =========================================================
   TIMESHOPEE · APP MODE (installed / "Add to Home Screen")
   1. Pull to refresh   (only inside the installed app)
   2. Install + open tracking -> your Google Sheet (optional)
   3. In-app notice popup + app icon badge (app users only)
   ========================================================= */
(function () {
  if (window.__nvApp) return;
  window.__nvApp = true;

  var root = document.documentElement;
  var cfg = window.nvAppConfig || {};
  var ua = navigator.userAgent || '';
  var isIOS = /iphone|ipad|ipod/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  var isAndroid = /android/i.test(ua);
  var standalone = (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) || window.navigator.standalone === true;

  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* private mode */ } }

  /* ---------------------------------------------------------
     2. tracking
  --------------------------------------------------------- */
  function deviceId() {
    var id = lsGet('nv_device_id');
    if (!id) {
      id = 'd' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
      lsSet('nv_device_id', id);
    }
    return id;
  }

  function track(event) {
    var payload = {
      id: deviceId(),
      event: event,
      platform: isIOS ? 'ios' : (isAndroid ? 'android' : 'other'),
      standalone: standalone,
      path: location.pathname,
      ua: ua.slice(0, 160)
    };
    // Google Sheet (Apps Script) - see PWA-SETUP.md
    if (cfg.trackUrl) {
      try {
        fetch(cfg.trackUrl, {
          method: 'POST',
          mode: 'no-cors',
          keepalive: true,
          body: JSON.stringify(payload) // string body = simple request, no CORS preflight
        });
      } catch (e) { /* ignore */ }
    }
    // Google Analytics 4 / GTM, if the store has them
    try {
      if (typeof window.gtag === 'function') window.gtag('event', 'pwa_' + event, { platform: payload.platform });
      (window.dataLayer = window.dataLayer || []).push({ event: 'pwa_' + event, pwa_platform: payload.platform });
    } catch (e) { /* ignore */ }
  }

  window.addEventListener('appinstalled', function () { track('installed'); });

  if (standalone) {
    root.classList.add('nv-standalone');
    // one "open" per app session
    var sent = false;
    try { sent = sessionStorage.getItem('nv_open_sent') === '1'; } catch (e) { /* ignore */ }
    if (!sent) {
      try { sessionStorage.setItem('nv_open_sent', '1'); } catch (e) { /* ignore */ }
      track(lsGet('nv_first_open_done') ? 'open' : 'first_open');
      lsSet('nv_first_open_done', '1');
    }
  }

  if (!standalone) return; // everything below is for the installed app only

  /* ---------------------------------------------------------
     1. pull to refresh
  --------------------------------------------------------- */
  (function ptr() {
    var el = document.getElementById('nv-ptr');
    if (!el) return;
    var TH = 72, MAX = 120;
    var startY = 0, startX = 0, dist = 0, pulling = false, busy = false;

    function pageBlocked() {
      var b = document.body;
      if (b.classList.contains('overflow-hidden') || b.style.overflow === 'hidden') return true;
      var cd = document.querySelector('cart-drawer');
      return !!(cd && cd.classList.contains('active'));
    }
    // true if the touch started inside something that can still scroll up by itself
    function insideScrolledBox(node) {
      while (node && node !== document.body && node !== root) {
        if (node.nodeType === 1) {
          var cs = getComputedStyle(node);
          if ((cs.overflowY === 'auto' || cs.overflowY === 'scroll') && node.scrollHeight > node.clientHeight && node.scrollTop > 0) return true;
        }
        node = node.parentNode;
      }
      return false;
    }
    function setPull(d) {
      var y = Math.min(d, MAX);
      el.style.transform = 'translate(-50%,' + (y - 56) + 'px)';
      el.style.opacity = Math.min(1, y / TH);
      el.querySelector('.nv-ptr__ico').style.transform = 'rotate(' + (y * 4) + 'deg)';
      el.classList.toggle('is-ready', y >= TH);
    }
    function reset() {
      el.classList.remove('is-pulling');
      el.style.transform = '';
      el.style.opacity = '';
      el.classList.remove('is-ready');
    }

    document.addEventListener('touchstart', function (e) {
      if (busy || e.touches.length !== 1) return;
      if ((window.scrollY || root.scrollTop) > 0 || pageBlocked() || insideScrolledBox(e.target)) { pulling = false; return; }
      startY = e.touches[0].clientY;
      startX = e.touches[0].clientX;
      dist = 0;
      pulling = true;
    }, { passive: true });

    document.addEventListener('touchmove', function (e) {
      if (!pulling || busy) return;
      var dy = e.touches[0].clientY - startY;
      var dx = e.touches[0].clientX - startX;
      if (dy <= 0 || Math.abs(dx) > dy) { // going up, or a sideways swipe (sliders)
        if (dist === 0) pulling = false;
        return;
      }
      if ((window.scrollY || root.scrollTop) > 0) { pulling = false; reset(); return; }
      dist = dy * 0.5; // a little resistance
      el.classList.add('is-pulling');
      setPull(dist);
      if (e.cancelable) e.preventDefault();
    }, { passive: false });

    function end() {
      if (!pulling) return;
      pulling = false;
      if (dist >= TH) {
        busy = true;
        el.classList.remove('is-pulling');
        el.classList.add('is-loading');
        el.style.transform = 'translate(-50%, 16px)';
        el.style.opacity = '1';
        setTimeout(function () { location.reload(); }, 350);
      } else {
        reset();
      }
      dist = 0;
    }
    document.addEventListener('touchend', end, { passive: true });
    document.addEventListener('touchcancel', end, { passive: true });
  })();

  /* ---------------------------------------------------------
     3. in-app notice (+ icon badge)
  --------------------------------------------------------- */
  (function notice() {
    var n = cfg.notice;
    var box = document.getElementById('nv-notice');
    if (!n || !n.enabled || !box) return;
    var KEY = 'nv_notice_seen';
    var id = String(n.id || '1');
    if (lsGet(KEY) === id) return;

    function badge(on) {
      try {
        if (on && navigator.setAppBadge) navigator.setAppBadge(1);
        if (!on && navigator.clearAppBadge) navigator.clearAppBadge();
      } catch (e) { /* not supported */ }
    }
    function close() {
      lsSet(KEY, id);
      badge(false);
      box.classList.remove('is-on');
      setTimeout(function () { box.hidden = true; }, 300);
      track('notice_closed');
    }

    badge(true);
    setTimeout(function () {
      box.hidden = false;
      requestAnimationFrame(function () { box.classList.add('is-on'); });
      track('notice_shown');
    }, 1200);

    box.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-notice-close],[data-notice-go]');
      if (!t) return;
      if (t.hasAttribute('data-notice-go')) track('notice_clicked');
      close();
    });
  })();
})();
